import * as ActionType from 'constants/action-types/organization';

export default (state, { type, payload }) => {
  switch (type) {
    case ActionType.DUPLICATE_BULK_PAYMENT_POS_START:
      return {
        ...state,
        duplicateBulkPayments: {
          ...state.duplicateBulkPayments,
          loading: true,
          error: null,
        },
      };
    case ActionType.DUPLICATE_BULK_PAYMENT_POS_SUCCESS:
      return {
        ...state,
        duplicateBulkPayments: {
          ...state.duplicateBulkPayments,
          data: payload,
          error: null,
          loading: false,
        },
      };
    case ActionType.DUPLICATE_BULK_PAYMENT_POS_ERROR:
      return {
        ...state,
        duplicateBulkPayments: {
          ...state.duplicateBulkPayments,
          data: payload,
          error: null,
          loading: false,
        },
      };

    default:
      return null;
  }
};
